<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="ConfigItem" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-row v-if="actiontype == 'add'  && C.Env != 'pro'" ref="checkEnvs">
                    <a-form-item label="所属环境">
                        <a-checkbox-group v-model="checkEnvs">
                            <a-checkbox v-for="item in envList" :key="item" :value="item" name="click">
                                {{item}}
                            </a-checkbox>

                        </a-checkbox-group>
                    </a-form-item>
                </a-row>
                <a-row v-if="actiontype == 'edit'">
                    <a-form-item label="所属环境">
                        <a-tag color="green">{{C.Env}}</a-tag>
                    </a-form-item>
                </a-row>
                <a-form-model-item ref="beanid" label="beanid" prop="beanid">
                    <a-input v-model="ConfigItem.beanid" @click="handleServicekeyModal" />
                    <ServiceKeySelecter :modalState="modalStateServicekey" @onModalHide="onServiceKeyselecterHide"></ServiceKeySelecter>
                </a-form-model-item>

                <a-form-model-item ref="businesstype" label="业务类型" prop="businesstype">
                    <a-input v-model="ConfigItem.businesstype" />
                </a-form-model-item>

                <a-form-model-item ref="businesstypename" label="业务全称" prop="businesstypename">
                    <a-input v-model="ConfigItem.businesstypename" />
                </a-form-model-item>
                <!-- 导出配置 -->
                <a-form-model-item ref="filenameprefix" label="文件前缀" prop="filenameprefix" v-if="isExport">
                    <a-input v-model="ConfigItem.filenameprefix" />
                </a-form-model-item>

                <a-form-model-item ref="datacountperfile" label="分文件的条数" prop="datacountperfile" v-if="isExport">
                    <a-input-number v-model="ConfigItem.datacountperfile" v-decorator="['input-number', { initialValue: ConfigItem.datacountperfile }]" :min="1" />
                </a-form-model-item>

                <a-form-model-item ref="maxdatacount" label="最大导出条数" prop="maxdatacount" v-if="isExport">
                    <a-input-number v-model="ConfigItem.maxdatacount" v-decorator="['input-number', { initialValue: ConfigItem.maxdatacount }]" :min="1" />
                </a-form-model-item>

                <!-- 导入配置 -->
                <a-form-model-item ref="startindex" label="开始行数" prop="startindex" v-if="!isExport">
                    <a-input-number v-model="ConfigItem.startindex" v-decorator="['input-number', { initialValue: ConfigItem.startindex }]" :min="1" />
                </a-form-model-item>

                <a-form-model-item prop="bigflag" v-if="!isExport">
                    <span slot="label">
                        是否大文件导入&nbsp;
                        <a-tooltip title="大文件导入使用方式:https://wiki.cnzhonglunnet.com/pages/viewpage.action?pageId=46268603">
                            <a-icon type="question-circle-o" />
                        </a-tooltip>
                    </span>
                    <a-radio-group v-model="ConfigItem.bigflag">
                        <a-radio value="1">
                            是
                        </a-radio>
                        <a-radio value="0">
                            否
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="datacountlimit" label="最大条数限制" prop="datacountlimit" v-if="!isExport && ConfigItem.bigflag == '0'">
                    <a-input-number v-model="ConfigItem.datacountlimit" v-decorator="['input-number', { initialValue: ConfigItem.datacountlimit }]" :min="1" />
                </a-form-model-item>

                <a-form-model-item ref="datacountperquery" label="分页查询条数" prop="datacountperquery" v-if="isExport">
                    <a-input-number v-model="ConfigItem.datacountperquery" v-decorator="['input-number', { initialValue: ConfigItem.datacountperquery }]" :min="1" />
                </a-form-model-item>

                <a-form-model-item label="是否压缩" prop="zipflag" v-if="isExport">
                    <a-radio-group v-model="ConfigItem.zipflag">
                        <a-radio value="1">
                            是
                        </a-radio>
                        <a-radio value="0">
                            否
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item label="是否保存成功记录" prop="savesuccessresult" v-if="!isExport && ConfigItem.bigflag == '0'">
                    <a-radio-group v-model="ConfigItem.savesuccessresult">
                        <a-radio value="1">
                            是
                        </a-radio>
                        <a-radio value="0">
                            否
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item label="版本" prop="version">
                    <a-radio-group v-model="ConfigItem.version">
                        <a-radio value="V3.0">
                            3.0
                        </a-radio>
                        <a-radio value="V5.0">
                            5.0
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item label="复合表格" prop="iscomplex">
                    <a-radio-group v-model="ConfigItem.iscomplex">
                        <a-radio value="0">
                            否
                        </a-radio>
                        <a-radio value="1">
                            是
                        </a-radio>
                        <a-radio value="2">
                            是 + 多sheet
                        </a-radio>
                        <a-radio value="3">
                            否 + 多sheet
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item ref="mergcolumnlines" label="复合表头名称被合并的列数" prop="mergcolumnlines" v-if="!isExport">
                    <a-input v-model="ConfigItem.mergcolumnlines" />
                </a-form-model-item>
                <a-form-model-item ref="bottomrows" label="复合表格底部表头行数" prop="bottomrows" v-if="!isExport">
                    <a-input-number v-model="ConfigItem.bottomrows" v-decorator="['input-number', { initialValue: ConfigItem.bottomrows }]" :min="0" />
                </a-form-model-item>

                <a-form-model-item label="excel 头配置" prop="columnheadconfig" v-if="isExport">
                    <editor v-model="ConfigItem.columnheadconfig" @init="editorInit" lang="json" theme="monokai" :options="aceOps" width="100%" height="600"></editor>
                </a-form-model-item>
                <a-form-model-item label="字段名" prop="columnstr" v-if="!isExport">
                    <editor v-model="ConfigItem.columnstr" @init="editorInit" lang="json" theme="monokai" :options="aceOps" width="100%" height="300"></editor>
                </a-form-model-item>

                <a-form-model-item label="列名" prop="columnnamestr" v-if="!isExport">
                    <editor v-model="ConfigItem.columnnamestr" @init="editorInit" lang="json" theme="monokai" :options="aceOps" width="100%" height="300"></editor>

                </a-form-model-item>

                <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>

</template>
<script>
import Editor from 'vue2-ace-editor'
import ServiceKeySelecter from '../../../components/ServiceKeySelecter'
// 代码格式化方法
// import {
//     formatJson,
// } from "@/utils/data_format_utils";

const rules = {
    checkEnvs: [
        {
            required: true,
            message: '请输勾选环境',
        },
    ],
    beanid: [
        { required: true, message: '请选择servicekey', trigger: 'change' },
    ],
    version: [{ required: true, message: '请选版本', trigger: 'change' }],
    businesstype: [
        { required: true, message: '请填写业务类型', trigger: 'blur' },
        { max: 50, message: '不能超过50位', trigger: 'blur' },
    ],
    businesstypename: [
        { required: true, message: '请填写业务全称', trigger: 'blur' },
        { max: 50, message: '不能超过50位', trigger: 'blur' },
    ],
    columnheadconfig: [
        { required: true, message: '请填写excel 头配置', trigger: 'blur' },
    ],
    filenameprefix: [
        { required: true, message: '请填写文件前缀', trigger: 'blur' },
        { max: 32, message: '不能超过50位', trigger: 'blur' },
    ],
    mergcolumnlines: [
        {
            required: false,
            message: '复合表格表头名称被合并列数，列数以逗号隔开',
            trigger: 'blur',
        },
    ],
    bottomrows: [
        { required: false, message: '复合表格底部表头行数', trigger: 'blur' },
    ],
    datacountperfile: [
        { required: true, message: '请填写分文件的条数', trigger: 'blur' },
    ],
    maxdatacount: [
        { required: true, message: '请填写配置项参数', trigger: 'blur' },
    ],
    startindex: [
        { required: true, message: '请填写开始行数', trigger: 'blur' },
    ],
    datacountlimit: [
        { required: true, message: '最大条数限制', trigger: 'blur' },
    ],
    bigflag: [
        { required: true, message: '请输入是否大文件导入', trigger: 'blur' },
    ],
    iscomplex: [{ required: true, message: '请选择', trigger: 'blur' }],
    columnstr: [{ required: true, message: '请填写字段名', trigger: 'blur' }],
    columnnamestr: [{ required: true, message: '请填写列名', trigger: 'blur' }],
    savesuccessresult: [
        { required: true, message: '请填写是否保存成功记录', trigger: 'blur' },
    ],
}
const m_title = {
    mt: '商家平台',
    mts: '菜场平台',
    pm: '运营平台',
    scp: '供应商平台',
    fp: '磐石',
    mall: '商圈平台',
    govifm: '市场监管平台',
}

export default {
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules,
            c_title: '',
            ConfigItem: {
                beanid: '',
                zipflag: '0',
                bigflag: '0',
            },
            formItemLayout: 'horizontal',
            is_vue_task: true,
            type: '',
            extype: '',
            isExport: true,
            aceOps: {
                wrap: true,
            },
            actiontype: '',
            modalStateServicekey: {
                isShow: false,
                rowsType: 'radio',
                domain: '',
                selectkeys: [],
            },
            envList: ['pre', 'uat', 'pet', 'fat', 'sit', 'sim', 'dev'],
            checkEnvs: ['pre', 'uat', 'pet', 'fat', 'sit', 'sim', 'dev'],
        }
    },

    methods: {
        handleServicekeyModal() {
            this.modalStateServicekey.filterServicekey = []
            this.modalStateServicekey.isShow = true
        },
        onServiceKeyselecterHide(result) {
            if (result == undefined) {
                this.modalStateServicekey.isShow = false
                return
            }
            this.ConfigItem.beanid = result[0].servicekey
            this.ConfigItem.domain = result[0].domain
            this.modalStateServicekey.isShow = false
        },
        handleOk() {
            let that = this
            if (this.$route.params.action == 'copy') {
                this.ConfigItem.id = undefined
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // this.ConfigItem.columnheadconfig = JSON.stringify(JSON.parse(that.ConfigItem.columnheadconfig))
                    let c_params = {
                        platformcode: that.type,
                        ...this.ConfigItem,
                        urlparams: false,
                    }
                    let ctype =
                        'filemanager/updatecommon' + that.extype + 'config'
                    if (!c_params.id) {
                        ctype = 'filemanager/addcommon' + that.extype + 'config'
                    }
                    if (this.actiontype == 'add' && this.C.Env != 'pro') {
                        this.handleCover(0, c_params, ctype)
                    } else {
                        that.$store
                            .dispatch({
                                type: ctype,
                                params: c_params,
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    this.message.success('保存成功！')
                                    that.handleCancel()
                                    that.confirmLoading = false
                                } else {
                                    this.message.error('更新失败')
                                }
                            })
                    }
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleCover(c_index, c_params, ctype) {
            //appenv
            //id
            let that = this
            console.log(c_index)
            let params = c_params
            params.appenv = that.checkEnvs[c_index]
            that.$store
                .dispatch({
                    type: ctype,
                    params: c_params,
                })
                .then((response) => {
                    if (c_index < that.checkEnvs.length - 1) {
                        that.handleCover(c_index + 1, c_params, ctype)
                    } else {
                        if (response.data.success == '1') {
                            this.message.success('保存成功！')
                            that.handleCancel()
                            that.confirmLoading = false
                        } else {
                            this.message.error('更新失败')
                        }
                    }
                })
        },
        getConfigItem(query) {
            let that = this
            this.$store
                .dispatch({
                    type: 'filemanager/detailcommon' + that.extype + 'config',
                    params: {
                        platformcode: that.type,
                        ...query,
                    },
                })
                .then((response) => {
                    if (response.data.success == '1') {
                        let resultD = response.data.data
                        // if(resultD.columnheadconfig){

                        //     // resultD.columnheadconfig = formatJson(JSON.parse(resultD.columnheadconfig))
                        // }
                        // if(resultD.columnstr){
                        //     resultD.columnstr = formatJson(JSON.parse(resultD.columnstr))
                        // }
                        // if(resultD.columnnamestr){
                        //     resultD.columnnamestr = formatJson(JSON.parse(resultD.columnnamestr))
                        // }

                        that.ConfigItem = resultD
                    } else {
                        that.message.error('找不到对应配置')
                        that.$router.back(-1)
                    }
                })
        },
        handleCancel() {
            this.$router.back(-1)
        },
        resetForm() {
            this.$refs.ruleForm.resetFields()
        },

        editorInit() {
            require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/json') //language
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
    },
    computed: {},
    components: {
        Editor,
        ServiceKeySelecter,
    },
    mounted() {
        const { query, params } = this.$route
        let exname = query.extype == 'export' ? '-导出配置-' : '-导入配置-'
        let editname = query.id && params.action != 'copy' ? '编辑' : '新建'
        this.c_title = m_title[query.type] + exname + editname
        this.actiontype = params.action
        this.type = query.type
        this.extype = query.extype
        this.isExport = query.extype == 'export'
        if (query.id) {
            this.getConfigItem(query)
        }
    },
}
</script>

<style scoped>
</style>